import React, { useMemo } from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { Row } from "common/components";
import { Button } from "components/bootstrap";
import { IfPermitted, Spinner, ModalButtonToolbar } from "components/common";
function UserFormButtons({ isEditing, onCancel }) {
  const { t } = useTranslation("enterprise_security_assets");
  const { isValid, dirty, isSubmitting, submitForm } = useFormikContext();
  const submitText = useMemo(() => {
    if (isEditing) return isSubmitting ? t("user_form_buttons.saving") : t("user_form_buttons.save_asset");
    return isSubmitting ? t("user_form_buttons.creating") : t("user_form_buttons.create_asset");
  }, [isEditing, isSubmitting, t]);
  return /* @__PURE__ */ React.createElement(ModalButtonToolbar, null, /* @__PURE__ */ React.createElement(Button, { onClick: onCancel }, t("common:actions.cancel")), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "asset:edit" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: submitForm, disabled: !isValid || !dirty || isSubmitting }, /* @__PURE__ */ React.createElement(Row, { $align: "center" }, isSubmitting && /* @__PURE__ */ React.createElement(Spinner, { text: "" }), submitText))));
}
export default UserFormButtons;
